/**
 * Ícones das redes na vitrine (Simple Icons, CC0). Importados um a um para a página pública
 * carregar só estes desenhos. LinkedIn saiu do Simple Icons a pedido da marca: vai literal.
 * `site`, `email` e `link` são traços do Lucide (ISC).
 */
import {
  siInstagram, siWhatsapp, siTiktok, siYoutube, siFacebook, siX, siThreads, siSpotify,
  siTelegram, siPinterest, siGooglemaps,
} from 'simple-icons';
import { glifoDeMarca } from '../icons/simpleBrandIcons.js';

// O LinkedIn saiu do Simple Icons: o desenho mora no registro de marcas do app (um lugar só).
const LINKEDIN = glifoDeMarca('linkedin').path;

/** Preenchidos (marcas). */
export const ICONES_CHEIOS = {
  instagram: siInstagram.path,
  whatsapp: siWhatsapp.path,
  tiktok: siTiktok.path,
  youtube: siYoutube.path,
  facebook: siFacebook.path,
  x: siX.path,
  threads: siThreads.path,
  spotify: siSpotify.path,
  telegram: siTelegram.path,
  pinterest: siPinterest.path,
  maps: siGooglemaps.path,
  linkedin: LINKEDIN,
};

/** Traço (genéricos). */
export const ICONES_TRACO = {
  site: ['M12 2a10 10 0 1 0 0 20a10 10 0 1 0 0-20', 'M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20', 'M2 12h20'],
  email: ['M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z', 'm22 7-10 6L2 7'],
};

const NS = 'http://www.w3.org/2000/svg';

/** `<svg>` do ícone da rede, em `currentColor`. */
export function svgDaRede(rede, tamanho = 22) {
  const svg = document.createElementNS(NS, 'svg');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('width', String(tamanho));
  svg.setAttribute('height', String(tamanho));
  svg.setAttribute('aria-hidden', 'true');
  if (ICONES_CHEIOS[rede]) {
    svg.setAttribute('fill', 'currentColor');
    const p = document.createElementNS(NS, 'path');
    p.setAttribute('d', ICONES_CHEIOS[rede]);
    svg.append(p);
  } else {
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    for (const d of ICONES_TRACO[rede] || ICONES_TRACO.site) {
      const p = document.createElementNS(NS, 'path');
      p.setAttribute('d', d);
      svg.append(p);
    }
  }
  return svg;
}
